import React, { useState } from 'react';
import { Box, Tab, Tabs, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Layout } from '../components/Layout';
import { PermissionGuard } from '../components/PermissionGuard';
import { UsersManagement } from '../features/admin/users/UsersManagement';
import { RolesManagement } from '../features/admin/roles/RolesManagement';
import { DeletedEnsayosList } from '../features/admin/ensayos/DeletedEnsayosList';
import { NomenclaturaDocumentManagement } from '../features/admin/documents/NomenclaturaDocumentManagement';

type AdminView = 'users' | 'roles' | 'deleted_ensayos' | 'documents';

export const AdminUsers: React.FC = () => {
  const { t } = useTranslation();
  const [view, setView] = useState<AdminView>('users');

  return (
    <PermissionGuard permission="MANAGE_USERS">
      <Layout>
        <Box>
          <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
            <Typography
              variant="h4"
              sx={{
                fontWeight: 700,
                letterSpacing: '-0.5px',
              }}
            >
              {t('admin.title', { defaultValue: 'Administración' })}
            </Typography>
          </Box>

          <Tabs
            value={view === 'users' ? 0 : view === 'roles' ? 1 : view === 'deleted_ensayos' ? 2 : 3}
            onChange={(_, newValue) => {
                if (newValue === 0) setView('users');
                else if (newValue === 1) setView('roles');
                else if (newValue === 2) setView('deleted_ensayos');
                else setView('documents');
            }}
            sx={{ mb: 3 }}
          >
            <Tab label={t('admin.users')} />
            <Tab label={t('admin.roles')} />
            <Tab label="Ensayos Borrados" />
            <Tab label={t('admin.documents', 'Documentación')} />
          </Tabs>

          {view === 'users' && <UsersManagement />}
          {view === 'roles' && <RolesManagement />}
          {view === 'deleted_ensayos' && <DeletedEnsayosList />}
          {view === 'documents' && <NomenclaturaDocumentManagement />}
        </Box>
      </Layout>
    </PermissionGuard>
  );
};


